import axios from '@/http/axios';
import {route} from '@/http/ziggy';

/**
 * Perform login action.
 *
 * @return {Promise}
 */
export const login = ({email, password, remember}) => axios.post(route('auth.login.process'), {email, password, remember});

/**
 * Perform registration action.
 *
 * @param {Object} formData
 *
 * @returns {Promise}
 */
export const register = (formData) => axios.post(route('auth.register.process'), formData);

/**
 * Send a reset password request to the Back-End.
 *
 * @returns {Promise}
 */
export const passwordReset = ({email}) => axios.post(route('password.email'), {email});

/**
 * Fetch the authenticated User from Back-End.
 *
 * @return {Promise}
 */
export const user = () => axios.get(route('app.auth.user'));

/**
 * Send request to reset password.
 *
 * @param token
 * @param email
 * @param password
 * @param password_confirmation
 *
 * @return {Promise}
 */
export const resetPassword = ({token, email, password, password_confirmation}) => axios.post(route('password.update'), {token, email, password, password_confirmation});

/**
 * Send request to set the User password.
 *
 * @param user_id
 * @param password
 * @param password_confirmation
 *
 * @return {Promise}
 */
export const setPassword = ({user_id, password, password_confirmation}) => axios.put(route('catchers.core.auth.set_password'), {user_id, password, password_confirmation});

/**
 * Sends request to save the User profile.
 *
 * @param {Object} profileData
 *
 * @return {Promise}
 */
export const saveProfile = (profileData) => axios.put(route('app.auth.user.profile.update'), profileData);

export default {
  login,
  register,
  user,
  passwordReset,
  resetPassword,
  setPassword,
  saveProfile,
}
